import React, { useEffect, useState } from "react";
import { fetchNWSActive, eventColor } from "../utils/nws";
import { AlertTriangle } from "lucide-react";

const AlertsTicker = () => {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    let cancel = false;
    const load = async () => {
      const data = await fetchNWSActive();
      if (!cancel) setAlerts(data.slice(0, 20));
    };
    load();
    const t = setInterval(load, 60000);
    return () => { cancel = true; clearInterval(t); };
  }, []);

  const items = alerts.length > 0 ? [...alerts, ...alerts] : [];

  const fmtExpires = (iso) => {
    if (!iso) return "";
    try {
      const d = new Date(iso);
      return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    } catch (_) { return ""; }
  };

  return (
    <div className="h-9 bg-gradient-to-r from-red-900/40 via-black/60 to-red-900/40 border-b border-red-500/20 flex items-center overflow-hidden text-xs">
      <div className="px-3 h-full flex items-center gap-2 bg-red-600 text-white font-bold uppercase tracking-wider text-[11px]">
        <AlertTriangle className="w-3.5 h-3.5" /> NWS Alerts
      </div>
      <div className="relative flex-1 overflow-hidden">
        {items.length === 0 ? (
          <div className="pl-6 py-1 mono text-slate-300 text-[11px]">
            <span className="text-emerald-300 font-bold">ALL CLEAR</span>
            <span className="text-slate-500 mx-2">·</span>
            <span>No active NWS watches or warnings.</span>
          </div>
        ) : (
          <div className="flex whitespace-nowrap marquee-track gap-8 pl-6">
            {items.map((a, i) => {
              const c = eventColor(a.event);
              return (
                <span key={`${a.id}-${i}`} className="inline-flex items-center gap-2 py-1 pr-4 mono" style={{ color: c.stroke }}>
                  <span className="font-bold">{a.event}</span>
                  <span className="text-slate-500">·</span>
                  <span className="text-slate-200">{a.areaDesc}</span>
                  {a.expires && (
                    <>
                      <span className="text-slate-500">·</span>
                      <span className="text-slate-500">expires {fmtExpires(a.expires)}</span>
                    </>
                  )}
                </span>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default AlertsTicker;
